import Vue from 'vue';
import { createDecorator } from 'vue-class-component';
import { vueBailDepCollector } from './vueBailDepCollector';
const defaultIsEqual = (a, b) => a === b;

/**
 * Vue 的渲染机制非常的诡异，如果它依赖了一个 computed，
 * 那么只要 computed 的计算过程发生了变化，即使最后输出的值不变，也会导致重新渲染！！！！
 *
 * 为了避免无必要的奇怪重新渲染，可以用这个方法，为组件注册一个 computed 字段，然后在 render 里安全的使用这个字段。
 *
 * 注意：calmComputed 后的变量，只能用于 render 或者 watch 里。用在其他地方（比如 methods 里）访问，有几率拿到旧的值！
 *
 * 使用步骤：
 *
 * 1. 在 computed 里：    something: calmComputed(function() {  return ....  })
 *
 * @template T
 * @param {(this: Vue) => T} getter
 * @param {(a: T, b: T)=>boolean} [isEqual]
 * @return {() => T}
 */
export function calmComputed(getter, isEqual) {
  counter += 1;
  const uniqKey = `$${counter}`;

  // eslint-disable-next-line no-param-reassign
  if (!isEqual) isEqual = defaultIsEqual;
  return function calmComputedGetter() {
    let collection = this[calmComputedCollectionKey];
    if (!collection) {
      collection = Vue.observable({});
      this[calmComputedCollectionKey] = collection;
    }
    if (!(uniqKey in collection)) {
      // 避免 Dep 污染
      vueBailDepCollector(() => {
        Vue.set(collection, uniqKey, getter.call(this));
        this.$watch(getter, newVal => {
          if (isEqual(newVal, collection[uniqKey])) return;
          collection[uniqKey] = newVal;
        });
      });
    }
    return collection[uniqKey];
  };
}
let counter = 0;
const calmComputedCollectionKey = '$_calmComputed';

/**
 * 修饰器的用法，配合 vue-class-component 的写法
 *
 * 示例：
 *
 * ```
 * @CalmComputedGetter()
 * get something() {
 *   return ...
 * }
 * ```
 *
 * @type {(equalFn?: (a,b)=>boolean) => PropertyDecorator}
 */
export const CalmComputedGetter = equalFn => createDecorator((options, key) => {
  const rawGetter = options.computed[key].get;
  options.computed[key].get = calmComputed(rawGetter, equalFn);
});